import React from 'react';
import { useInput, InputProps } from 'react-admin';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

interface CheckValueInputProps extends InputProps {
    checkedValue: string;
    label?: string;
}


export const CheckValueInput = (props: CheckValueInputProps) => {
    const { source, checkedValue, label } = props;
    const {
        field, // contains: name, onChange, onBlur, value, ref
        fieldState: { error },

    } = useInput(props)


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        
        field.onChange(event.target.checked ? checkedValue : null);

    };
    
    return (
        <FormControl error={!!error} component="fieldset">
            <FormControlLabel
                control={
                    <Checkbox
                        // {...field}
                        name={field.name}
                        checked={field.value == checkedValue}
                        onChange={handleChange}
                        inputRef={field.ref}
                    />
                }
                label={label || source}
            />
            {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
    );
};


